var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2218 6.10352C17.4593 6.32227 17.6843 6.54727 17.8968 6.77852L20.4562 7.14414C20.8732 7.86836 21.1946 8.64357 21.4124 9.45039L19.8562 11.5223C19.8562 11.5223 19.8843 12.1598 19.8562 12.4785L21.4124 14.5504C21.1956 15.3576 20.8741 16.1329 20.4562 16.8566L17.8968 17.2223C17.8968 17.2223 17.4562 17.6816 17.2218 17.8973L16.8562 20.4566C16.1319 20.8737 15.3567 21.1951 14.5499 21.4129L12.478 19.8566C12.1599 19.8848 11.8399 19.8848 11.5218 19.8566L9.4499 21.4129C8.64274 21.1961 7.8674 20.8746 7.14365 20.4566L6.77803 17.8973C6.54678 17.6785 6.32178 17.4535 6.10303 17.2223L3.54365 16.8566C3.12664 16.1324 2.80521 15.3572 2.5874 14.5504L4.14365 12.4785C4.14365 12.4785 4.11553 11.841 4.14365 11.5223L2.5874 9.45039C2.8042 8.64322 3.12568 7.86789 3.54365 7.14414L6.10303 6.77852C6.32178 6.54727 6.54678 6.32227 6.77803 6.10352L7.14365 3.54414C7.86788 3.12712 8.64308 2.8057 9.4499 2.58789L11.5218 4.14414C11.8399 4.11601 12.1599 4.11601 12.478 4.14414L14.5499 2.58789C15.3571 2.80469 16.1324 3.12617 16.8562 3.54414L17.2218 6.10352Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInactive);
export default __webpack_public_path__ + "static/media/settings_inactive.64a41cacb558623a80e1898010903efd.svg";
export { ForwardRef as ReactComponent };